import request from '@/utils/request'



//查询营销线索记录
export function queryClueRecord(data) {
  return request({
    url: '/admin/clue/queryClueRecord',
    method: 'post',
    data: data
  })
}

//创建一条营销线索记录
export function createOneClueRecord(data) {
  return request({
    url: '/admin/clue/createOneClueRecord',
    method: 'post',
    data: data
  })
}

//跟进创建一条营销线索记录
export function followCreateOneClueRecord(data) {
  return request({
    url: '/admin/clue/followCreateOneClueRecord',
    method: 'post',
    data: data
  })
}
//查询一个用户的线索记录时间线
export function queryUserClues(data) {
  return request({
    url: '/admin/clue/queryUserClues',
    method: 'post',
    data: data
  })
}








// WEBPACK FOOTER //
// ./src/api/MktClueManager.js